import * as React from 'react';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import { isEmpty } from 'lodash';
import styled from 'styled-components';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { buildResultUrl, fixRedirectUrl } from '@doltech/utils/lib/url';
import { getFinalUrlGrammar } from '../../../../shared/utils';

const EmptySpace = styled.div`
  height: 20px;
`;


const Container = styled.div`
  .header {
    padding: 0 16px;
  }
`;

const ItemLink = styled.a`
  display: flex;
  cursor: pointer;
  padding: 10px 16px;

  &:hover {
    background-color: ${colorsV2.gray5};
  }
`;

interface SuggestPreviewListByTypeProps {
  data?: any;
  onItemClick?: () => void;
}

export const SuggestPreviewListByType = ({ data, onItemClick }: SuggestPreviewListByTypeProps) => {

  if (isEmpty(data)) {
    return <EmptySpace/>;
  }

  return (
    <Container>
      <ResponsiveTypography.Paragraph className="header" variant="semi-bold/14-20" color="gray100">
        PHỔ BIẾN
      </ResponsiveTypography.Paragraph>
      {data?.map((item: any) => {
          const { name, id, url } = item || {};
          if (!url) {
            return null;
          }
          const customLink = buildResultUrl({
            appPrefix: '',
            url: {
              pathname: getFinalUrlGrammar(fixRedirectUrl(url)),
            },
          });
          return (
            <ItemLink key={id} href={customLink} onClick={onItemClick}>
              <ResponsiveTypography.Paragraph
                variant="regular/14-20"
                ellipsis={{ rows: 3, tooltip: true }}
                color="gray180"
              >
                {name}
              </ResponsiveTypography.Paragraph>
            </ItemLink>
          );
        },
      )}
    </Container>
  );
};
